import { Button, ControlGroup, NumericInput, Tag } from "@blueprintjs/core";
import React from "react";
import { compareTwoObjects } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";

class AnaesthesiaPriceMaster extends React.Component {
  state = {
    changed: false,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  anaesthesiaTypes = [
    "Local Anaesthesia",
    "General Anaesthesia",
    "Topical Anaesthesia",
    "Lid Block",
  ];
  render() {
    return (
      <>
        <td>
          <SingleSelectWrapper
            items={this.anaesthesiaTypes}
            showSelectProp={true}
            selectedItem={this.state.anaesthesiaType}
            onChange={(anaesthesiaType) =>
              this.setState(
                { anaesthesiaType: anaesthesiaType, changed: true },
                () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
              )
            }
          />
        </td>
        <td>
          <SingleSelectWrapper
            items={this.props.sites}
            showSelectProp={true}
            selectedItem={this.state.site}
            onChange={(site) =>
              this.setState({ site: site, changed: true }, () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
              )
            }
          />
        </td>

        <td>
          <ControlGroup>
            <NumericInput
              style={{ width: "9em" }}
              value={this.state.hospitalCharge / 100}
              buttonPosition="NONE"
              rightElement={<Tag minimal>₹</Tag>}
              onValueChange={(number) =>
                this.setState({ hospitalCharge: number * 100 })
              }
              onBlur={() => {
                const { hospitalCharge } = this.state;
                if (!isNaN(hospitalCharge)) {
                  this.setState(
                    {
                      ratePaise:
                        this.state.anaesthetistFee + this.state.hospitalCharge,

                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  );
                }
              }}
            />
            {/* <Button
              disabled={!this.state.hospitalCharge}
              icon="tick-circle"
              minimal
              onClick={() => {
                const { hospitalCharge } = this.state;
                if (!isNaN(hospitalCharge)) {
                  this.setState(
                    {
                      ratePaise:
                        this.state.anaesthetistFee + this.state.hospitalCharge,

                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  );
                }
              }}
            /> */}
          </ControlGroup>
        </td>
        <td>
          <ControlGroup>
            <NumericInput
              style={{ width: "9em" }}
              value={this.state.anaesthetistFee / 100}
              buttonPosition="NONE"
              rightElement={<Tag minimal>₹</Tag>}
              onValueChange={(number) =>
                this.setState({ anaesthetistFee: number * 100 })
              }
              onBlur={() => {
                const { anaesthetistFee } = this.state;
                if (!isNaN(anaesthetistFee)) {
                  this.setState(
                    {
                      ratePaise:
                        this.state.hospitalCharge + this.state.anaesthetistFee,

                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  );
                }
              }}
            />
            {/* <Button
              disabled={!this.state.anaesthetistFee}
              icon="tick-circle"
              minimal
              onClick={() => {
                const { anaesthetistFee } = this.state;
                if (!isNaN(anaesthetistFee)) {
                  this.setState(
                    {
                      ratePaise:
                        this.state.hospitalCharge + this.state.anaesthetistFee,

                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  );
                }
              }}
            /> */}
          </ControlGroup>
        </td>
        <td>
          {/* <NumericInput
            style={{ width: "9em" }}
            value={this.state.ratePaise / 100}
            buttonPosition="NONE"
            rightElement={<Tag minimal>₹</Tag>}
            onValueChange={(number) =>
              this.setState(
                {
                  ratePaise: number * 100,
                  changed: true,
                },
                () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
              )
            }
          /> */}
          <Tag>{this.state.ratePaise / 100}</Tag>
        </td>
      </>
    );
  }
}

export default inject("authStore")(observer(AnaesthesiaPriceMaster));
